import "./style.css";
import {store} from "../store";
import {isMobile} from "pixi.js";
import {useRef} from "react";
import {observer} from "mobx-react";
import React, {useState, useEffect} from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import {getUserSpinsHistory} from "../api";
import {t, TKeys} from "../translationService";
import {multipliersNumsById, SYMBOLS, SYMBOLS_ID} from "../constants/configs";

export const showHistorySection = () => {
    initializeHistory();
    document.getElementById("historySectionWrapper").style.display = "flex";
}
export const hideHistorySection = () => {
    document.getElementById("historySectionWrapper").style.display = "none";
    setEmptyHistory();
}

export const HistorySection = observer(() => {
        return <div id={"historySectionWrapper"} onClick={hideHistorySection}>
            <div className={`historySection  ${isMobile.phone ? "fullScreenSize" : "historySectionSize"}`}
                 onClick={(e) => e.stopPropagation()}
            >
                <img src={"./assets/singleIcons/close.svg"} id={"historySectionCloseIcon"} onClick={hideHistorySection}/>
                <div className={"historySectionTitle"}>{t(TKeys.HISTORY)}</div>
                {store.accessToken ? <InfiniteScrollComponent/> : <></>}
            </div>
        </div>
    }
)

let historyCurrentPage = 0;
let initializeHistory = () => {
};
let setEmptyHistory = () => {
};
const InfiniteScrollComponent = () => {
    const [dataSource, setDataSource] = useState([]);
    const [hasMore, setHaseMore] = useState(true);

    const fetchMoreData = async (adding = true) => {
        historyCurrentPage += 1;
        const data = await getUserSpinsHistory(historyCurrentPage, store.gameId);
        if (adding) {
            setDataSource([...dataSource, ...data.data.list])
        } else {
            setDataSource([...data.data.list])
        }
        if (!data.data.list.length) {
            setHaseMore(false);
        }
    }

    initializeHistory = () => {
        historyCurrentPage = 0;
        setHaseMore(true);
        fetchMoreData(false);
    }

    setEmptyHistory = () => {
        setDataSource([]);
        setHaseMore(true);
    }

    return (
        <div id="customScroll" style={{height: isMobile.phone ? '90%' : '370px', overflow: 'auto', color: "#fff"}}>
            <InfiniteScroll
                dataLength={dataSource.length}
                next={fetchMoreData}
                hasMore={hasMore}
                scrollableTarget="customScroll"
                loader={<Loading isHaveDataLoaded={dataSource.length}/>}
            >
                {
                    dataSource.map((bet) => {
                        return <HistoryDropdownComponent bet={bet} key={bet.id}/>
                    })
                }
            </InfiniteScroll>
        </div>
    );
};


const HistoryDropdownComponent = ({bet}) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const handleDropdownClick = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    correctionSpinItemsInfo(bet);


    return (
        <div
            className={`dropdown-container`}
        >
            <div className="dropdown-header" onClick={handleDropdownClick}>

                <div className="dropdown-header-info">
                    <div>{bet.amount}</div>
                    <div style={{textAlign: "center"}}>X{bet.odd}</div>
                    <div style={{textAlign: "right"}}>{bet.winAmount}</div>
                </div>
                <span style={{fontFamily: "Arial"}}>{isDropdownOpen ? <UpIcon/> : <DownIcon/>}</span>
            </div>

            {isDropdownOpen && (
                <>
                    <div
                        className={`dropdown-content ${isMobile.phone ? "dropdown-content-vertical" : "dropdown-content-horizontal"}`}>
                        {bet.items.map((item) => {
                            return <HistoryBoard info={item} key={bet.id + JSON.stringify(item) + Math.random()}/>
                        })}
                    </div>
                    {bet.freeSpins ?
                        bet.freeSpins.map((spin) => {
                            return <div id={spin.id}>
                                <div className={"freeSpinsHistoryLine"}></div>
                                <div
                                    className={`dropdown-content ${isMobile.phone ? "dropdown-content-vertical" : "dropdown-content-horizontal"}`}>
                                    {spin.items.map((item) => {
                                        return <HistoryBoard info={item}
                                                             key={bet.id + JSON.stringify(item) + Math.random()}/>
                                    })}</div>
                            </div>
                        }) : ""
                    }
                </>
            )}
        </div>
    );
};

const UpIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="13" height="20" viewBox="0 0 13 9" fill="none">
        <path d="M1 8L6.5 2L12 8" stroke="white" strokeWidth="2"/>
    </svg>
}
const DownIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="13" height="20" viewBox="0 0 13 9" fill="none">
        <path d="M1 1L6.5 7L12 1" stroke="white" strokeWidth="2"/>
    </svg>
}


const historyCanvasConfigs = {
    width: 700,
    height: 600,
    padding: 15,
    symbolConfig: {
        size: 108,
        scale: 0.43,
        margin: 4,
    }
}

const HistoryBoard = ({info}) => {
    const {width, height, padding, symbolConfig} = historyCanvasConfigs;
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        info.cards.forEach((reel, reelIndex) => {
            reel.forEach((symbol, symbolIndex) => {
                if (symbol < 10) {
                    ctx.globalAlpha = info.explodedSymbols[symbol] ? 1 : 0.5;
                    const x = padding + reelIndex * (symbolConfig.size + symbolConfig.margin) + symbolConfig.size / 2 - (iconImages[symbol].width * symbolConfig.scale / 2);
                    const y = padding + symbolIndex * (symbolConfig.size + symbolConfig.margin) + symbolConfig.size / 2 - (iconImages[symbol].height * symbolConfig.scale / 2);
                    ctx.drawImage(iconImages[symbol], x, y, iconImages[symbol].width * symbolConfig.scale, iconImages[symbol].height * symbolConfig.scale);
                }
            })
        })

        info.cards.forEach((reel, reelIndex) => {
            reel.forEach((symbol, symbolIndex) => {
                if (symbol > 9) {
                    ctx.globalAlpha = info.explodedSymbols[symbol] ? 1 : 0.5;
                    const x = padding + reelIndex * (symbolConfig.size + symbolConfig.margin) + symbolConfig.size / 2 - (iconImages[symbol].width * symbolConfig.scale / 2);
                    const y = padding + symbolIndex * (symbolConfig.size + symbolConfig.margin) + symbolConfig.size / 2 - (iconImages[symbol].height * symbolConfig.scale / 2);
                    ctx.drawImage(iconImages[symbol], x, y, iconImages[symbol].width * symbolConfig.scale, iconImages[symbol].height * symbolConfig.scale);
                }
            })
        })

    }, []);

    return <div className={"history-board"}>
        <canvas ref={canvasRef} width={width} height={height}></canvas>
        <div className={"result"}>
            <div>X{info.odd}</div>
            <div style={{textAlign: "right"}}>{info.winAmount}</div>
        </div>
    </div>
}

const correctionSpinItemsInfo = (bet) => {
    if (bet.freeSpins) {
        bet.freeSpins.forEach((spin) => {
            correctionSpinItemsInfo(spin);
        })
    }

    const lastItem = bet.items[bet.items.length - 1];
    let overallMultiplayer = 0;

    if (lastItem.scattersCount) {
        lastItem.cards.forEach((reel) => {
            reel.forEach((symbol) => {
                if (symbol === 10) {
                    lastItem.explodedSymbols[symbol] = 1;
                }
            })
        })
    }

    if (bet.items.length === 1) {
        return;
    }


    lastItem.cards.forEach((reel) => {
        reel.forEach((symbol) => {
            if (symbol > 10) {
                lastItem.explodedSymbols[symbol] = 1;
                overallMultiplayer += multipliersNumsById[symbol];
                lastItem.winAmount = (bet.winAmount - (bet.winAmount / overallMultiplayer)).toFixed(2);
                lastItem.odd = `${bet.multiplier} ${t(TKeys.MULTIPLIER)}`;
            }
        })
    })
};

const Loading = ({isHaveDataLoaded}) => {
    return <div className="loading-container"
                style={!isHaveDataLoaded ? {
                    margin: isMobile.phone ? "60% auto" : "120px auto"
                } : {}}>
        <div className="loading"></div>
    </div>
}

const creatImgDom = (url) => {
    const img = document.createElement("img");
    img.src = url;
    return img;
}


const iconImages = {
    1: creatImgDom(`./assets/singleIcons/${SYMBOLS[1]}.webp`),
    2: creatImgDom(`./assets/singleIcons/${SYMBOLS[2]}.webp`),
    3: creatImgDom(`./assets/singleIcons/${SYMBOLS[3]}.webp`),
    4: creatImgDom(`./assets/singleIcons/${SYMBOLS[4]}.webp`),
    5: creatImgDom(`./assets/singleIcons/${SYMBOLS[5]}.webp`),
    6: creatImgDom(`./assets/singleIcons/${SYMBOLS[6]}.webp`),
    7: creatImgDom(`./assets/singleIcons/${SYMBOLS[7]}.webp`),
    8: creatImgDom(`./assets/singleIcons/${SYMBOLS[8]}.webp`),
    9: creatImgDom(`./assets/singleIcons/${SYMBOLS[9]}.webp`),
    10: creatImgDom(`./assets/singleIcons/${SYMBOLS[10]}.webp`),
    11: creatImgDom(`./assets/singleIcons/iconX2.webp`),
    12: creatImgDom(`./assets/singleIcons/iconX3.webp`),
    13: creatImgDom(`./assets/singleIcons/iconX4.webp`),
    14: creatImgDom(`./assets/singleIcons/iconX5.webp`),
    15: creatImgDom(`./assets/singleIcons/iconX6.webp`),
    16: creatImgDom(`./assets/singleIcons/iconX8.webp`),
    17: creatImgDom(`./assets/singleIcons/iconX10.webp`),
    18: creatImgDom(`./assets/singleIcons/iconX12.webp`),
    19: creatImgDom(`./assets/singleIcons/iconX15.webp`),
    20: creatImgDom(`./assets/singleIcons/iconX20.webp`),
    21: creatImgDom(`./assets/singleIcons/iconX25.webp`),
    22: creatImgDom(`./assets/singleIcons/iconX50.webp`),
    23: creatImgDom(`./assets/singleIcons/iconX100.webp`),
    24: creatImgDom(`./assets/singleIcons/iconX250.webp`),
    25: creatImgDom(`./assets/singleIcons/iconX500.webp`),
}
